import React from 'react';
import PropTypes, { string } from 'prop-types';
import { StyleSheet, View, ScrollView } from 'react-native-web';

import { Box, Inline } from '@styleseat/ui';
import Image from '../../../../shared/Image';
import { APP } from '../../../../../config';

import {
  LearnMoreLink,
  EducationModalCTAButton,
} from '../../../../shared';

import {
  HeaderText,
  Stack,
  Separator,
  Modal,
} from '../../../../ui';

import './VirtualServiceEducationModal.module.scss';

const LionImage = require('../../../../../../images/icons/styleseat-lion-black.svg');

const BLOG_LINK = 'https://www.styleseat.com/blog/top-5-reasons-why-you-should-add-a-virtual-service-to-your-menu-today/';
const styles = StyleSheet.create({
  icon: {
    width: 55,
    height: 55,
  },
  iconContainer: {
    width: 55,
    height: 80,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const HeaderImage = ({ source }) => (
  <View style={styles.iconContainer}>
    <Image
      source={source}
      style={styles.icon}
      resizeMode="contain"
    />
  </View>
);

HeaderImage.propTypes = {
  source: string.isRequired,
};

const VirtualServiceEducationModal = ({
  onCloseModal,
  providerId,
  copy,
  ...props
}) => {
  const handleLearnMoreClick = evt => {
    if (APP) {
      evt.preventDefault();
      window.open(BLOG_LINK, '_system');
    }

    if (typeof onCloseModal === 'function') {
      onCloseModal();
    }
  };

  return (
    <Modal
      onCloseRequest={onCloseModal}
      theme="yellow"
      appearance="fullScreen"
      {...props}
    >
      <ScrollView style={StyleSheet.absoluteFill}>
        <Box paddingX={16} paddingBottom={32}>
          <HeaderImage source={LionImage} />
          <HeaderText>Can&apos;t be in the salon?</HeaderText>
          <Separator />

          <Box paddingY={16}>
            <Stack space={20}>
              {copy}
              <Inline>
                <EducationModalCTAButton
                  onClick={onCloseModal}
                  clickTracking="virtual_service_education_modal_settings_clicked"
                  link="responsive.provider.services.add_services"
                  linkParams={{ providerId, category: 43 }}
                >
                  Add a virtual service!
                </EducationModalCTAButton>
              </Inline>
              <Inline styleName="settingsRow" alignItems="flex-start">
                <LearnMoreLink
                  href={BLOG_LINK}
                  linkTarget="_blank"
                  clickTracking="virtual_service_education_modal_learn_more_clicked"
                  onClick={handleLearnMoreClick}
                >
                  Learn More
                </LearnMoreLink>
              </Inline>
            </Stack>
          </Box>
        </Box>
      </ScrollView>
    </Modal>
  );
};

VirtualServiceEducationModal.propTypes = {
  onCloseModal: PropTypes.func,
  copy: PropTypes.node,
  providerId: PropTypes.any,
};

VirtualServiceEducationModal.defaultProps = {
  onCloseModal: null,
  copy: null,
  providerId: null,
};

export default VirtualServiceEducationModal;
